import React from "react";
import { useQuery } from "react-query";

import {
  // Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";

import styled from "styled-components/macro";

import Table from "../../../components/Table";
import { spacing } from "@material-ui/system";
import Panel from "../../../components/panels/Panel";
// import Link from "@material-ui/core/Link";
// import { NavLink } from "react-router-dom";

import { Helmet } from "react-helmet-async";
import Loader from "../../../components/Loader";
import { dateFormatter } from "../../../utils";
import axios from "axios";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  max-height: calc(100% - 48px);
`;

const Divider = styled(MuiDivider)(spacing);
// const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

//388px
const SitesSummaryTable = () => {
  const { data, isFetching, error } = useQuery(
    ["/api/site-param-summary-table"],
    async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/site-param-summary-table`
        );

        return data;
      } catch (err) {
        console.error(err);
      }
    },
    { keepPreviousData: true, refetchOnWindowFocus: false }
  );

  if (error) return "An error has occurred: " + error.message;

  const tabColumns = [
    {
      title: "Location Name",
      field: "location_name",
    },
    {
      title: "Location Type",
      field: "location_type",
    },
    {
      title: "Parameter",
      field: "parameter",
    },
    {
      title: "Data Provider",
      field: "data_provider",
    },
    {
      title: "HUC8",
      field: "huc8",
    },
    // {
    //   title: "Irrigation Type",
    //   field: "irgg_type",
    // },
    {
      title: "Starting Period of Record",
      field: "start_por",
      render: (rowData) => {
        return dateFormatter(rowData.start_por, "MM/DD/YYYY");
      },
    },
    {
      title: "Ending Period of Record",
      field: "end_por",
      render: (rowData) => {
        return dateFormatter(rowData.end_por, "MM/DD/YYYY");
      },
    },
    {
      title: "Years",
      field: "years",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Latitude",
      field: "latitude",
      filtering: false,
    },
    {
      title: "Longitude",
      field: "longitude",
      filtering: false,
    },
    {
      title: "External Data Link",
      field: "loc_url",
      render: (rowData) => {
        return rowData.location_urls
          ? rowData.location_urls.split(",").map((item) => {
              return (
                <div key={item}>
                  <a target="_blank" href={item.split(";")[1]} rel="noreferrer">
                    <>{item.split(";")[0]}</>
                  </a>
                </div>
              );
            })
          : "N/A";
      },
      filtering: false,
    },
  ];

  return (
    <>
      <Helmet title="Site Summary Table" />
      <Typography variant="h3" gutterBottom display="inline">
        Site Summary Table
      </Typography>

      {/*<Breadcrumbs aria-label="Breadcrumb" mt={2}>*/}
      {/*  <Link component={NavLink} exact to="/dashboard">*/}
      {/*    Dashboard*/}
      {/*  </Link>*/}
      {/*  <Typography>Site Summary Table</Typography>*/}
      {/*</Breadcrumbs>*/}

      <Divider my={6} />
      <Panel>
        <TableWrapper>
          {data ? (
            <Table
              label="Site Summary Table"
              isLoading={isFetching}
              columns={tabColumns}
              data={data}
              height="calc(100vh - 64px - 48px - 106px - 48px - 64px - 156px)"
              pageSize={60}
              options={{ filtering: true }}
            />
          ) : (
            <Loader />
          )}
        </TableWrapper>
      </Panel>
    </>
  );
};

export default SitesSummaryTable;
